import { Outlet, useMatches } from 'react-router';
import type { Handle } from '../App';
import { Nav } from './Nav';

const Layout = () => {
  const matches = useMatches();
  const isPrimary = matches.some(
    (m) => m.handle && (m.handle as Handle).isPrimary,
  );

  return (
    <div className="flex flex-col h-svh">
      <main className="flex-1 overflow-y-auto min-h-0">
        <Outlet />
      </main>
      {isPrimary && (
        <div className="w-full pt-4">
          <Nav />
        </div>
      )}
    </div>
  );
};

export default Layout;
